import apiClient from "./apiClient";

export const fetchSocialActivities = async () => {
    const response = await apiClient.get("/api/social_activity/all");
    return response.data;
};

export const updateSocialActivity = async (id, data) => {
    const response = await apiClient.put(`/api/social_activity/${id}`, data);
    return response.data;
};